// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Srm1","header":"ReportDetails_header__37-SY","title":"ReportDetails_title__3o6H2","left":"ReportDetails_left__flRKw"};